
<template>
  <div class="jobTags pr">
    <!-- <div class="formTips f_12 color_9c pa">*可添加8个关键词突出展示给求职者</div> -->
    <div class="restInput button f_14 cursor_p placeholder" @click.stop="toError({type:'profession_id',text:'请选择职位类别'})" v-if="!profession_id">请选择职位关键词</div>
    <template v-else>
      <div class="searchBox cursor_p clearfix pr" @click.stop>
        <div class="toggle pa" @click.stop="toggleSelectState"></div>
        <!-- 选中的tags -->
        <div class="tags fl f_14 color_40 bg_f9" v-for="(item,index) in job_tags" :key="String(index)">
          {{item}}<span class="iconfont iconguanbi color_cf pr" @click.stop="delBoxTags(item,index)"></span>
        </div>
        <input class="addTagsValue f_14 color_40 fl pr" v-model="addTagsValue" placeholder="请选择或输入职位关键词" :maxlength="20" ref="addTagsValue"
        @focus="inputFocusFunc()"
        @input="searchTagsValue" @keyup.enter="enterSearchTags(addTagsValue)"
        />
        <!-- 选择列表 -->
        <div class="selectTags pa bg_fff" :class="[user_add_tags.length || user_check_tags.length?'':'notList']" v-if="selectTagsState && !(addTagsValue.length || searchTags.length)" @click.stop>
          <template v-if="user_add_tags.length || user_check_tags.length">
            <div class="tagList clearfix" v-if="user_add_tags.length">
              <div class="item fl f_14 cursor_p" :class="[item.check?'active color_fff bg_current':'color_9c']" v-for="(item,index) in user_add_tags" :key="String(index)" @click.stop="checkTags(item,index,'add')">{{item.tag}}</div>
            </div>
            <div class="tagList clearfix" v-if="user_check_tags.length">
              <div class="item fl f_14 cursor_p" :class="[item.check?'active color_fff bg_current':'color_9c']" v-for="(item,index) in user_check_tags" :key="String(index)" @click.stop="checkTags(item,index,'check')">{{item.tag}}</div>
            </div>
          </template>
          <div class="tips f_14 color_9c" v-else>当前职位暂无关键词，可自定义关键词</div>
        </div>
        <!-- 搜索列表 -->
        <div class="searchTags pa bg_fff" v-if="searchTagsState && (addTagsValue.length || searchTags.length)">
          <div class="item f_14 color_9c flex" v-if="!searchTags.length" @click="enterSearchTags(addTagsValue)">
            <div class="flex1">{{addTagsValue}}</div>
            <div class="color_9c">回车添加标签</div>
          </div>
          <template v-else>
            <div class="item f_14 color_9c" v-for="(item,index) in searchTags" :key="String(index)" @click="enterSearchTags(item)" >
              <div class="flex1">{{item}}</div>
              <div class="color_9c"></div>
            </div>
          </template>
        </div>
      </div>
    
    </template>
  </div>
</template>

<script>
  // 所有接口
  import actions from '@/actions/index'

  import { mapState, mapMutations } from 'vuex'
  
  export default {
    name: 'jobTags',
    props: {
    },
    data() {
      return {
        addTagsValue:'',
        searchTags:[],
        isComposing:false, //搜索框值，仅做监听
      }
    },
    created() {
      if(this.profession_id){
        //根据描述和类型获取相应的标签
        // this.get_jd_to_skills();
        //获取所有标签列表
        this.get_profession_skills_info();
      }
    },
    computed: {
      ...mapState('jobEdit', ['profession_id', 'job_tags', 'user_check_tags','user_add_tags','selectTagsState','searchTagsState','storeJd', ]),
    },
    methods: {
      ...mapMutations('jobEdit', ['updateSelectTagsState', 'updateSearchTagsState','updateJobTags','updateUserCheckTags','updateUserAddTags']),

      inputFocusFunc () {
        this.$emit('jobBrightSpot', false)
        this.updateSelectTagsState(true)
        this.updateSearchTagsState(true)
        this.toError({type:'job_tags',text:''})
      },
      //box删除列表
      delBoxTags(item,index){
        let job_tags = JSON.parse(JSON.stringify(this.job_tags));
        let user_add_tags = JSON.parse(JSON.stringify(this.user_add_tags));
        let user_check_tags = JSON.parse(JSON.stringify(this.user_check_tags));

        let CheckIndex = -1
        let AddIndex = -1
        user_check_tags.forEach((sitem,sindex)=>{
          if(sitem.tag === item){
            CheckIndex = sindex;
          }
        });
        user_add_tags.forEach((sitem,sindex)=>{
          if(sitem.tag === item){
            AddIndex = sindex;
          }
        });

        if(CheckIndex>-1){
          user_check_tags[CheckIndex].check = false;
          //更新用户选中tags
          this.updateUserCheckTags(user_check_tags);
        }else if(AddIndex>-1){
          user_add_tags[AddIndex].check = false;
          //更新用户自己添加的tags
          this.updateUserAddTags(user_add_tags);
        }
        //删除选中列表
        job_tags.splice(index,1);
        this.updateJobTags(job_tags);


      },
      //点击删除/添加
      checkTags(item,index,type){
        let job_tags = JSON.parse(JSON.stringify(this.job_tags));
        let user_add_tags = JSON.parse(JSON.stringify(this.user_add_tags));
        let user_check_tags = JSON.parse(JSON.stringify(this.user_check_tags));

        if (!item.check && this.job_tags.length >= 8){
          this.$message({
            message: '职位关键词最多选择8个',
            type: 'warning'
          });
          return false;
        }
        if(type==='add'){
          user_add_tags[index].check = user_add_tags[index].check?false:true;
          //更新用户自己添加的tags
          this.updateUserAddTags(user_add_tags);
        }else{
          user_check_tags[index].check = user_check_tags[index].check ? false : true;
          //更新用户选中tags
          this.updateUserCheckTags(user_check_tags);
        }
        //执行删除
        if(item.check){
          let checkIndex = 0;
          job_tags.forEach((sitem,sindex)=>{
            if(sitem===item.tag){
              checkIndex = sindex;
            }
          })
          job_tags.splice(checkIndex,1);
        }else{
          job_tags.push(item.tag);
        }
        // 更新用户选中的总tags
        this.updateJobTags(job_tags);
         
      },
      //【搜索】change
      searchTagsValue(e){
        let tags = this.user_check_tags.filter(item=>!item.check);
        let searchTags = [];
        this.isComposing = e.isComposing;

        if(!this.addTagsValue.length){
          this.searchTags = [];
          return false;
        }
        if(tags.length){
          tags.forEach(item=>{
            if(item.tag.toLowerCase().includes(this.addTagsValue.toLowerCase())){
              searchTags.push(item.tag)
            }
          })
        }
        this.searchTags = searchTags;
      },
      //enter
      enterSearchTags(value){
        let job_tags = JSON.parse(JSON.stringify(this.job_tags));
        let user_add_tags = JSON.parse(JSON.stringify(this.user_add_tags));
        let user_check_tags = JSON.parse(JSON.stringify(this.user_check_tags));
        value = value.trim();
        if(!value || this.isComposing){
          return false;
        }
        if(job_tags.length>=8){
          this.$message({
            message: '职位关键词最多选择8个',
            type: 'info'
          });
          return false
        }
        //回车的是已经选中的值
        if([value].filter(v => job_tags.indexOf(v) > -1 ).length>0){
          //清空搜索值&&清空搜索列表
          this.addTagsValue = '';
          this.searchTags = [];
          this.$refs.addTagsValue.focus();
          return false;
        }
        let CheckIndex = -1
        let AddIndex = -1
        user_check_tags.forEach((item,index)=>{
          if(item.tag.toLowerCase() === value.toLowerCase()){
            CheckIndex = index;
          }
        });
        user_add_tags.forEach((item,index)=>{
          if(item.tag.toLowerCase() === value.toLowerCase()){
            AddIndex = index;
          }
        });
        // 选择的是已经存在的
        if(CheckIndex>-1){
          user_check_tags[CheckIndex].check = true;
          //更新用户自己添加的tags
          this.updateUserCheckTags(user_check_tags);
          job_tags.push(user_check_tags[CheckIndex].tag);
        }else if( AddIndex>-1){
          user_add_tags[AddIndex].check = true;
          //更新用户自己添加的tags
          this.updateUserAddTags(user_add_tags);
          job_tags.push(user_add_tags[AddIndex].tag);
        }else{
          //不存在
          user_add_tags.push({
            check:true,
            tag:value
          })
          job_tags.push(value);
          //更新用户自己添加的tags
          this.updateUserAddTags(user_add_tags);
        }
        // 更新用户选中的总tags
        this.updateJobTags(job_tags);

        //清空搜索值&&清空搜索列表
        this.addTagsValue = '';
        this.searchTags = [];
        this.$refs.addTagsValue.focus();
        
      },

      //切换展示选择框
      toggleSelectState(){
        this.$emit('jobBrightSpot', false)
        this.toError({type:'job_tags',text:''});
        this.updateSelectTagsState(!this.selectTagsState);
        this.updateSearchTagsState(false);
      },
      //提示错误
      toError(data){
        this.$emit('updateErrorTips',data);
        // if(data.text){
        //   window.scrollTo({ 
        //     top:160, 
        //     behavior: "smooth" 
        //   });
        // }
      },
      //获取所有标签
      get_profession_skills_info(){
        actions.staticApi.get_profession_skills_info(this.profession_id).then(res=>{
          if(res.code ===1000){
            let jobTags = [];
            res.data.forEach(item=>{
              item.forEach(sitem=>{
                jobTags.push({
                  check:false,
                  tag:sitem
                })
              })
            })
            //更新接口tags
            this.updateUserCheckTags(jobTags);
            //检查哪些是选中的
            this.updateTags();

            //如果职位类型发生变化，重新检测职位关键词的匹配
            if(this.storeJd){
              setTimeout(() => {
                //根据描述和类型获取相应的标签
                this.get_jd_to_skills();
              }, 100);
            }
          }
        })
      },
      //根据描述和类型获取相应的标签
      get_jd_to_skills(){
        actions.staticApi.get_jd_to_skills({
          profession_id:this.profession_id,
          description:this.storeJd,
        }).then(res=>{
          if(res.code ===1000){
            let job_tags = res.data.filter(v => this.job_tags.indexOf(v) <= -1 );
            job_tags.length = job_tags > 8-this.job_tags.length? 8-this.job_tags.length : job_tags.length;
            this.updateJobTags(this.job_tags.concat(job_tags));

            //更新数据
            this.updateTags();
          }
        })
      },

      //更新标签选中状态
      updateTags(){
        let user_check_tags = []
        this.user_check_tags.forEach(item=>{
          if(this.job_tags.filter(v => [item.tag].indexOf(v) > -1 ).length){
            user_check_tags.push(item.tag);
          }
        })
        let user_add_tags = this.job_tags.filter(v => user_check_tags.indexOf(v) <= -1 );
        //用户自己添加的tags
        if(user_add_tags.length){
          let user_add_tags2 = []
          user_add_tags.forEach(item=>{
            user_add_tags2.push({
              check:true,
              tag:item
            })
          })
          this.updateUserAddTags(user_add_tags2)
        }
        // 更新接口tags
        if(user_check_tags.length){
          let user_check_tags2 = JSON.parse(JSON.stringify(this.user_check_tags))
          user_check_tags2.forEach(item=>{
            if([item.tag].filter(v => user_check_tags.indexOf(v) > -1 ).length){
              item.check = true;
            }
          })
          this.updateUserCheckTags(user_check_tags2)
        }
        // this.user_check_tags
        // 选择的是已经存在的
        // if(CheckIndex>-1){
        //   user_check_tags[CheckIndex].check = true;
        //   //更新用户自己添加的tags
        //   this.updateUserCheckTags(user_check_tags);
        //   job_tags.push(user_check_tags[CheckIndex].tag);
        // }else if( AddIndex>-1){
        //   user_add_tags[AddIndex].check = true;
        //   //更新用户自己添加的tags
        //   this.updateUserAddTags(user_add_tags);
        //   job_tags.push(user_check_tags[CheckIndex].tag);
        // }else{
        //   //不存在
        //   user_check_tags.push({
        //     check:true,
        //     tag:value
        //   })
        //   job_tags.push(value);
        //   //更新用户自己添加的tags
        //   this.updateUserAddTags(user_add_tags);
        // }
        
        

      },
    },
    watch:{
      //检测职位发生变化
      profession_id(newValue, oldValue){
        if(newValue){
          if(oldValue && Number(oldValue) !== Number(newValue)){
            //更新用户选择tag列表
            this.updateJobTags([])
            //更新接口tags
            this.updateUserCheckTags([])
            //用户自己添加的tags
            this.updateUserAddTags([])
          }
          //获取所有标签列表
          this.get_profession_skills_info();
        }
      },
      //检测职位描述发生变化
      storeJd(newValue, oldValue){
        if(this.profession_id){
          //根据描述和类型获取相应的标签
          this.get_jd_to_skills();
        }
      },
      //检测卡片状态发生变化
      searchTagsState(newValue, oldValue){
        if(!newValue){
          this.addTagsValue = '';
          this.searchTags = [];
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './jobTags.scss';
</style>
